import styled from "styled-components";

interface SortableTableHeaderProps {
    label: string;
    column: string;
    className?: string;
    currentSortBy: string;
    currentSortDirection: 'asc' | 'desc';
    onSort: (column: string) => void;
}

export function SortableTableHeader({
    label,
    column,
    className,
    currentSortBy,
    currentSortDirection,
    onSort
}: SortableTableHeaderProps) {
    const isActive = currentSortBy === column;

    return (
        <SortableTh className={className} onClick={() => onSort(column)}>
            <span className="header-content">
                {label}
                <span className="sort-arrows">
                    <span className={"arrow-up" + (isActive && currentSortDirection === 'asc' ? " active" : "")}>▴</span>
                    <span className={"arrow-down" + (isActive && currentSortDirection === 'desc' ? " active" : "")}>▾</span>
                </span>
            </span>
        </SortableTh>
    );
}

const SortableTh = styled.th`
    cursor: pointer;
    user-select: none;

    .header-content {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .sort-arrows {
        display: inline-flex;
        flex-direction: column;
        flex-shrink: 0;
        line-height: 0.5;
        font-size: 0.7rem;

        span {
            color: #C0C0C0;
        }

        span.active {
            color: #514F4E;
        }
    }

    &:hover .sort-arrows span {
        color: #999;
    }

    &:hover .sort-arrows span.active {
        color: #514F4E;
    }
`;
